/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as e from "react";
import { useZIndexContext as x } from "../contexts/ZIndexContext.mjs";
const m = (t) => e.forwardRef((n, o) => {
  const r = x();
  return /* @__PURE__ */ e.createElement(t, { ...n, ref: o, _zIndex: r });
});
export {
  m as withZIndexContext
};
